import { render, staticRenderFns } from "./settling the situation.vue?vue&type=template&id=68b484f3&scoped=true"
import script from "./settling the situation.vue?vue&type=script&lang=js"
export * from "./settling the situation.vue?vue&type=script&lang=js"
import style0 from "./settling the situation.vue?vue&type=style&index=0&id=68b484f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b484f3",
  null
  
)

export default component.exports